<div class="flex flex-col gap-3 pl-2 pr-2">
    <div class="flex flex-row gap-2 items-center border-b border-ponder-light border-opacity-10">
        <div class="font-bold">
            Set Progress
        </div>
        <div class="grow">
        </div>
        <div class="flex flex-row items-center gap-2 text-xs">
            <div class="flex flex-row items-center cursor-default gap-1" title="100%">
                <div class="w-2 h-2 shadow-sm rounded-sm" [style.background-color]="mythicColor">

                </div>
                <div>
                    {{ mythicCount }}
                </div>
            </div>
            <div class="flex flex-row items-center cursor-default gap-1" title=">= 85%">
                <div class="w-2 h-2 shadow-sm rounded-sm" [style.background-color]="rareColor">

                </div>
                <div>
                    {{ rareCount }}
                </div>
            </div>
            <div class="flex flex-row items-center cursor-default gap-1" title="< 85%">
                <div class="w-2 h-2 shadow-sm rounded-sm" [style.background-color]="uncommonColor">

                </div>
                <div>
                    {{ uncommonCount }}
                </div>
            </div>
        </div>
    </div>
    <div class="flex flex-row gap-2 items-center text-sm">
        <input #setFilterInput (input)="onFilterChange(setFilterInput.value)" class="p-[5px] rounded-sm shadow-sm bg-white w-[24ch]" placeholder="Filter ...">
        <div class="grow"></div>
        <div class="flex flex-row gap-1 items-center">
            <input #largeSetsCheckbox (input)="largeSetsOnly = !largeSetsOnly" type="checkbox">
            <div>Large Sets Only</div>
        </div>
    </div>
    @for (magicSet of magicSetProgress ; track magicSet.set.setCode) {
        @if (magicSet.isVisible && (!largeSetsOnly || magicSet.set.distinctCardCount >= 50)) {
            <magic-collection-set [magicSet]="magicSet"></magic-collection-set>
        }
    }
</div>